import { render, staticRenderFns } from "./DefaultPaymentMethodDrawer.vue?vue&type=template&id=166eddfc&scoped=true&"
import script from "./DefaultPaymentMethodDrawer.vue?vue&type=script&lang=js&"
export * from "./DefaultPaymentMethodDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166eddfc",
  null
  
)

export default component.exports